import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../../common/html/element'
import { COMPONENTS } from '../../../../routers/constants'

export const DetailCell = ({ val, isScreeningReport }) => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(
      COMPONENTS.userManagement.components.subscriptionPayment.components
        .orderDetail.route +
        '?orderId=' +
        val +
        (isScreeningReport ? '&isScreening=true' : ''),
    )
  }

  return (
    val && (
      <Element
        elementName="span"
        className="cursorPointer"
        style={{ color: '#2C73E8', whiteSpace: 'nowrap' }}
        onClick={onClick}
      >
        <Translate value="userManagement.orderManagement.DETAILS" />
      </Element>
    )
  )
}
